import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { useCallback, useEffect, useState } from 'react';
import { ModalCloseButton } from '~components/ui/ModalCloseButton';

interface Props {
  editHandler: () => void;
  isOpen: boolean;
  onCancel: () => void;
  onSuccess?: () => Promise<void> | void;
}

export function EditConfigurationModal({ editHandler, isOpen, onCancel }: Props) {
  const handleClose = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setDisabled(false);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('createdraftheading')}</ModalHeader>
        <ModalCloseButton tabIndex={5} />
        <ModalBody>
          <Text>{t('draftcreatemessage1')}</Text>
          <Text>{t('draftcreatemessage2')}</Text>
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClose} variant="ghost" colorScheme="blue">
            {t('cancel')}
          </Button>
          <Button
            variant="solid"
            colorScheme="blue"
            marginLeft="3"
            onClick={() => {
              setDisabled(true);
              editHandler();
            }}
            isDisabled={disabled}
          >
            {t('editdraftbutton')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
